import React, { useState } from 'react'
import { Doughnut, Pie, Line } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCertificate,
  faChevronDown,
  faChevronUp,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
// Custom Styles
import './styles.css'
// Leon Global Styles
import '../../../assets/css/Global/style.css'

const DoughnutChart = (props) => {
  let rgb
  let valueToShow

  let cutOne
  let cutTwo
  let cutThree

  let captionClassName

  if (props.chartUsers === 'chartUsers') {
    rgb = '6, 57, 81'
    valueToShow = props.numberOfAllUsers
    cutOne = '85%'
    cutTwo = '70%'
    cutThree = '78%'
    captionClassName = 'caption'
  } else if (props.chartUsers === 'chartCertiUsers') {
    rgb = '255, 183, 3'
    valueToShow = 0 + '%'
    cutOne = '78%'
    cutTwo = '73%'
    cutThree = '76%'
    captionClassName = 'caption-certified'
  } else if (props.chartUsers === 'chartMultiLocations') {
    rgb = '255, 183, 3'
    valueToShow = props.valueToShow + '%'
    cutOne = '78%'
    cutTwo = '73%'
    cutThree = '76%'
    captionClassName = 'caption-certified'
  }

  const firstDoughnutData = {
    datasets: [
      {
        data: [20, 80],
        backgroundColor: [`rgb(${rgb},.5)`, `rgb(${rgb},0)`],
      },
    ],
  }

  const firstDoughnutOptions = {
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },
    maintainAspectRatio: false,
    segmentShowStroke: false,
    cutout: cutOne,
    // circumference: 180,
  }
  const secondDoughnutData = {
    datasets: [
      {
        data: [20, 50, 30],
        backgroundColor: [`rgb(${rgb},0)`, `rgb(${rgb},1)`, `rgb(${rgb},0)`],
      },
    ],
  }

  const secondDoughnutOptions = {
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },
    maintainAspectRatio: false,
    segmentShowStroke: false,
    cutout: cutTwo,
    // circumference: 270,
  }
  const thirdDoughnutData = {
    datasets: [
      {
        data: [70, 30],
        backgroundColor: [`rgb(${rgb},0)`, `rgb(${rgb},.7)`],
      },
    ],
  }

  const thirdDoughnutOptions = {
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },
    maintainAspectRatio: false,
    segmentShowStroke: false,
    cutout: cutThree,
  }

  const fourthDoughnutData = {
    datasets: [
      {
        data: [20, 50, 30],
        backgroundColor: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)', 'rgba(0,0,0,0)'],
        borderColor: '#fff',
      },
    ],
  }

  const fourthDoughnutOptions = {
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },
    maintainAspectRatio: false,
    segmentShowStroke: false,
  }

  return (
    <div className='doughnut-chart-container'>
      <Doughnut
        data={firstDoughnutData}
        options={firstDoughnutOptions}
        id='dnChart1'
        className='circle01'
        height={200}
        width={200}
      ></Doughnut>

      <Doughnut
        data={thirdDoughnutData}
        options={thirdDoughnutOptions}
        id='dnChart3'
        className='circle03'
        height={200}
        width={200}
      ></Doughnut>
      <Doughnut
        data={secondDoughnutData}
        options={secondDoughnutOptions}
        id='dnChart2'
        className='circle02'
        height={200}
        width={200}
      ></Doughnut>
      <Doughnut
        data={fourthDoughnutData}
        options={fourthDoughnutOptions}
        id='dnChart4'
        className='frame'
        height={200}
        width={200}
      ></Doughnut>
      <div className={captionClassName}> {valueToShow} </div>
    </div>
  )
}

const PieChart = (props) => {
  let labels =
    props.locationPercentages && props.locationPercentages.locationNames
  let colorHex = ['#c13018', '#063951']
  let dataArray =
    props.locationPercentages && props.locationPercentages.overAllPercentage

  const pieData = {
    datasets: [
      {
        data: dataArray,
        backgroundColor: colorHex,
      },
    ],
    labels: labels,
  }

  const pieOptions = {
    // responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 15 },
    },
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },

    plugins: {
      datalabels: {
        color: '#fff',
        anchor: 'end',
        align: 'top',
        offset: -10,
        backgroundColor: (context) => {
          return context.dataset.backgroundColor
        },
        borderWidth: 0.3,
        borderColor: '#fff',
        borderRadius: 50,
        padding: 5,

        font: {
          size: '15',
        },

        formatter: (value) => {
          return value + ' %'
        },
      },

      legend: {
        display: true,
        position: 'bottom',
        align: 'center',

        labels: {
          font: {
            size: 15,
          },
          paddingTop: 40,
          boxWidth: 20,
          boxHeight: 10,
        },
      },
    },
  }

  return (
    <div className='doughnut-chart-container'>
      <Pie
        height={220}
        width={220}
        plugins={[ChartDataLabels]}
        options={pieOptions}
        data={pieData}
      ></Pie>
    </div>
  )
}

const ChartOne = (props) => {
  const [chartsViews, setChartsViews] = useState(0)

  let numberOfLocations =
    props.locationPercentages &&
    props.locationPercentages.locationNames &&
    props.locationPercentages.locationNames.length

  let labels =
    props.locationPercentages &&
    props.locationPercentages.locationNames.map((name) => {
      if (name.length >= 12) {
        return name.slice(0, 10) + '..'
      } else {
        return name.slice(0, 12)
      }
    })

  let widthBasedOnLocations = numberOfLocations >= 26 ? '100%' : '50%'

  let colorHex = ['#c13018', '#063951']
  let dataArray =
    props.locationPercentages && props.locationPercentages.overAllPercentage

  const sumOfCertified =
    props.locationPercentages &&
    props.locationPercentages.overAllPercentage.reduce((a, b) => {
      return a + b
    }, 0)

  const averageOfCertifiedPercantage = Math.round(
    sumOfCertified / numberOfLocations
  )

  const lineData = (canvas) => {
    const ctx = canvas.getContext('2d')

    const gradient = ctx.createLinearGradient(0, 0, 0, 450)

    gradient.addColorStop(0, 'rgb(185, 43, 39)')
    gradient.addColorStop(0.7, 'rgb(21, 101, 192,0.8)')

    return {
      labels: labels,

      datasets: [
        {
          label: 'Certified percentage by location',
          fill: 'origin',
          backgroundColor: gradient,
          borderColor: '#bdc3c7',
          pointBackgroundColor: sumOfCertified !== 0 ? 'white' : '#c13018',
          borderWidth: 1,
          layout: {
            padding: 100,
          },

          data: dataArray,
        },
      ],
    }
  }

  var lineOptions = {
    maintainAspectRatio: false,
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },

    layout: {
      padding: { top: 15 },
    },

    scales: {
      x: {
        gridLines: {
          color: 'rgba(200, 200, 200, 0.05)',
          lineWidth: 1,
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },

      y: {
        gridLines: {
          color: 'rgba(200, 200, 200, 0.08)',
          lineWidth: 1,
        },
        ticks: {
          font: { size: 10 },
        },
      },
    },
    elements: {
      line: {
        tension: 0.4,
      },
    },

    point: {
      backgroundColor: 'white',
    },

    plugins: {
      datalabels: {
        color: 'rgb(255, 183, 3)',
        anchor: 'end',
        align: 'top',

        font: {
          size: '10',
        },

        formatter: (value) => {
          return value + '%'
        },
      },
      legend: {
        display: false,
        position: 'bottom',
        align: 'center',

        labels: {
          font: {
            size: 10,
          },
          padding: 15,
          boxWidth: 20,
          boxHeight: 10,
        },
      },
    },
  }

  const pieData = {
    datasets: [
      {
        data: dataArray,
        backgroundColor: colorHex,
      },
    ],
    labels: labels,
  }

  const pieOptions = {
    // responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 15 },
    },
    animation: {
      // easing: 'easeInOutQuad',
      duration: 0,
    },

    plugins: {
      datalabels: {
        color: '#fff',
        anchor: 'end',
        align: 'top',
        offset: -10,
        backgroundColor: (context) => {
          return context.dataset.backgroundColor
        },
        borderWidth: 0.3,
        borderColor: '#fff',
        borderRadius: 50,
        padding: 5,

        font: {
          size: '15',
        },

        formatter: (value) => {
          return value + ' %'
        },
      },

      legend: {
        display: true,
        position: 'bottom',
        align: 'center',

        labels: {
          color: 'rgb(255,255,255,0)',
          font: {
            size: 15,
          },

          paddingTop: 40,
          boxWidth: 0,
          boxHeight: 0,
        },
      },
    },
  }

  return (
    <div
      style={{ width: '100%', maxHeight: '100%', overflowY: 'scroll' }}
      className='leon gap2 md-gap06 '
    >
      {numberOfLocations <= 20 ? (
        <React.Fragment>
          <React.Fragment>
            {props.locationPercentages &&
            props.locationPercentages.overAllPercentage.length > 2 ? (
              <div className='col7 md-col12'>
                <div
                  className='dFlex gap06 itemsCenter justifyCenter'
                  style={{ color: 'orange' }}
                >
                  {' '}
                  <i class='fas fa-certificate'></i>
                  <p>Certified percentage by locations</p>
                </div>
                <Line
                  className=''
                  height={240}
                  width={240}
                  plugins={[ChartDataLabels]}
                  options={lineOptions}
                  data={lineData}
                  style={{
                    maxHeight: '240px',
                  }}
                ></Line>
              </div>
            ) : (
              <React.Fragment>
                {sumOfCertified !== 0 ? (
                  <div className='col7 md-col12'>
                    <Pie
                      height={220}
                      width={220}
                      plugins={[ChartDataLabels]}
                      options={pieOptions}
                      data={pieData}
                    ></Pie>
                    <div
                      className='dFlex gap06 itemsCenter justifyCenter'
                      style={{ color: 'rgb(255, 183, 3)' }}
                    >
                      {' '}
                      <i class='far fa-compass'></i>
                      <p style={{ color: '#c13018' }} className='nameOne'>
                        {props.locationPercentages.locationNames[0]}
                      </p>
                      <p style={{ margin: '0 5px' }}>
                        {props.locationPercentages.locationNames.length === 2
                          ? '-'
                          : ''}
                      </p>
                      <p style={{ color: '#063951' }} className='nameTwo'>
                        {props.locationPercentages.locationNames[1]}
                      </p>
                    </div>
                  </div>
                ) : (
                  // <PieChart {...props} />
                  <div className='col7 md-col12'>
                    <DoughnutChart chartUsers={'chartCertiUsers'} {...props} />
                    <p
                      className='dFlex gap06 itemsCenter justifyCenter '
                      style={{ color: '#c13018' }}
                    >
                      {' '}
                      <i className='fas fa-certificate'></i>
                      <p>Certified in this filter</p>
                    </p>
                  </div>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
          <div className='chart03 col5 md-col12'>
            <p className='dFlex gap06 itemsCenter' style={{ color: '#c13018' }}>
              {' '}
              <i className='fas fa-users'></i>
              <p>Number of all users in this filter</p>{' '}
            </p>
            <DoughnutChart
              // style={{ width: "200px", height: "200px", position: "absolute" }}
              chartUsers={'chartUsers'}
              {...props}
            />
            <span></span>
          </div>
        </React.Fragment>
      ) : numberOfLocations > 20 && numberOfLocations <= 50 ? (
        <React.Fragment>
          {chartsViews === 0 ? (
            <div
              className='chart03'
              style={{
                width: '99%',
              }}
            >
              <Line
                height={220}
                width={220}
                plugins={[ChartDataLabels]}
                options={lineOptions}
                data={lineData}
              ></Line>
              <span id='chevron-down' onClick={() => setChartsViews(1)}>
                <FontAwesomeIcon icon={faChevronDown} />
              </span>
              <p className='caption-title-line mb-0'>
                {' '}
                <FontAwesomeIcon icon={faCertificate} />
                Certified percentage by locations
              </p>
            </div>
          ) : (
            <div
              className='chart03'
              style={{
                width: widthBasedOnLocations,
              }}
            >
              <DoughnutChart chartUsers={'chartUsers'} {...props} />
              <span id='chevron-up' onClick={() => setChartsViews(0)}>
                <FontAwesomeIcon icon={faChevronUp} />
              </span>
              <p className='caption-title mb-0'>
                {' '}
                <FontAwesomeIcon icon={faUsers} />
                Number of all users in this filter
              </p>
            </div>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div class='chart03'>
            <DoughnutChart
              chartUsers={'chartMultiLocations'}
              valueToShow={averageOfCertifiedPercantage}
              {...props}
            />
            <p className='caption-title mb-0 caption-multi-locations'>
              {' '}
              <i className='fas fa-certificate'></i>Average Certified
              percentages in this filter
            </p>
          </div>
          <div className='chart03'>
            <DoughnutChart chartUsers={'chartUsers'} {...props} />
            <span></span>
            <p className='caption-title mb-0'>
              {' '}
              <i className='fas fa-users'></i>Number of all users in this filter{' '}
            </p>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

const ChartTwo = (props) => {
  let valuePercentage = 0

  let backgroundColor
  let numOfUsers
  let transparentColor = 'rgb(0,0,0,0.03)'

  if (props.chart === 'N/A') {
    backgroundColor = '#3C3B3F'
  } else if (props.chart === 'In Progress') {
    backgroundColor = '#00A19D'
  } else if (props.chart === 'Not Started') {
    backgroundColor = '#FF2442'
  } else if (props.chart === 'Need Manager Approval') {
    backgroundColor = '#3DB2FF'
  } else if (props.chart === 'Certified') {
    backgroundColor = '#ffb100'
  }

  if (props.chart === 'N/A') {
    valuePercentage = props.percentage.notActivePercentage
  } else if (props.chart === 'In Progress') {
    valuePercentage = props.percentage.inProgressPercentage
  } else if (props.chart === 'Not Started') {
    valuePercentage = props.percentage.notStartedPercentage
  } else if (props.chart === 'Need Manager Approval') {
    valuePercentage = props.percentage.needsManagerApproval
  } else if (props.chart === 'Certified') {
    valuePercentage = props.percentage.certifiedPercentage
  }

  if (props.showCertificatePercentage && props.numberofUsers) {
    if (props.chart === 'N/A') {
      numOfUsers = props.numberofUsers.notAssigned
    } else if (props.chart === 'In Progress') {
      numOfUsers = props.numberofUsers.inProgress
    } else if (props.chart === 'Not Started') {
      numOfUsers = props.numberofUsers.notStarted
    } else if (props.chart === 'Need Manager Approval') {
      numOfUsers = props.numberofUsers.needsManagerApproval
    } else if (props.chart === 'Certified') {
      numOfUsers = props.numberofUsers.certified
    }
  }

  let leftPercentage = valuePercentage ? 100 - valuePercentage : 100
  let backgroundColors = [backgroundColor, transparentColor]

  const data = {
    labels: [props.chart],

    datasets: [
      {
        label: 'User Completed',
        data: [valuePercentage, leftPercentage],
        backgroundColor: backgroundColors,
        borderColor: backgroundColor,
        borderWidth: 0.25,
        cutout: '75%',
      },
    ],
  }

  const plugins = [
    {
      beforeDraw: function (chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.ctx

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center
          var fontStyle = centerConfig.fontStyle || 'Arial'
          var txt = centerConfig.text
          var subTxt = props.showCertificatePercentage ? `(${numOfUsers})` : ''
          var color = centerConfig.color || '#000'
          var maxFontSize = centerConfig.maxFontSize || 25
          var sidePadding = centerConfig.sidePadding || 20
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2)
          //Start with a base font of 30px
          ctx.font = '25px ' + fontStyle

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth
          var newFontSize = Math.floor(30 * widthRatio)
          var elementHeight = chart.innerRadius * 2

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize)

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
          ctx.font = fontSizeToUse + 'px ' + fontStyle
          ctx.fillStyle = color

          //Draw text in center
          ctx.fillText(txt, centerX, centerY)

          if (props.showCertificatePercentage) {
            ctx.font = '11px ' + fontStyle // Smaller font size
            ctx.fillText(subTxt, centerX, centerY + 23) // 👈 Adjust position below percentage
          }
        }
      },
    },
  ]

  return (
    <div
      className='chart-container'
      style={{ width: props.showCertificatePercentage ? '20%' : '25%' }}
    >
      <Doughnut
        data={data}
        height={170}
        width={170}
        options={{
          animation: {
            // easing: 'easeInOutQuad',
            duration: 0,
          },
          elements: {
            center: {
              text: valuePercentage ? valuePercentage + '%' : 0 + '%',
              color: backgroundColor, // Default is #000000
              fontStyle: 'Arial', // Default is Arial
              maxFontSize: 25, // Default is 25
              sidePadding: 20, // Defualt is 20 (as a percentage)
            },
          },
          plugins: {
            plugins: {
              fontColor: backgroundColor,
            },
            legend: {
              display: true,
              position: 'bottom',
              align: 'center',
              color: backgroundColor,

              labels: {
                boxWidth: 20,
                boxHeight: 10,
                color: backgroundColor,
              },
            },
            tooltip: {
              enabled: false,
            },
          },
          centerText: {
            display: true,
            text: `90%`,
          },
          maintainAspectRatio: false,
        }}
        plugins={plugins}
      />
      {props.fourth ? '' : <span></span>}
    </div>
  )
}

const Chart = (props) => {
  return props.chartNumber === 1 ? (
    <ChartOne {...props} />
  ) : (
    <ChartTwo {...props} />
  )
}

export default Chart
